import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'kpa-contact-admin',
	templateUrl: './contact-admin.component.html',
	styleUrl: './contact-admin.component.scss',
})
export class ContactAdminComponent {
	@Input() dialogOpened: boolean = false;
	@Output() closeDialog = new EventEmitter();
	constructor() {}

	public open(component: string): void {
		this[component + 'Opened'] = true;
	}

	public close(component: string): void {
		this[component + 'Opened'] = false;
		this.closeDialog.emit();
	}
}
